// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsCheckbox } from '@tectonics/prs/user-input-values';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { hasFeature } from '@tectonics/prs/feature';
import { Checkbox } from '../../../../atoms';

export function ArgentineTermsForWithholdTaxes(): Node {
  const [acceptTerms, setAcceptTerms] = useUserInputAsCheckbox('acceptTerms');
  const inputId = useUniqueId();
  const currentAllFeatures = useCurrentAllFeatures();

  if (!hasFeature(currentAllFeatures, 'field_argentine_accept_terms_withhold_taxes')) {
    return null;
  }

  return (
    <Content>
      <Checkbox
        id={inputId}
        checked={acceptTerms}
        onChange={setAcceptTerms}
        name="accept-terms-withhold-taxes"
      />

      <Paragraph>
        Autorizo a EBANX a retener los impuestos asociados a esta factura y pagarlos a AFIP.
      </Paragraph>
    </Content>
  );
}

const Content = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const Paragraph = styled.p`
  font-size: inherit;
  color: #000000;
  margin: 20px 0 0 5px;
  @media (max-width: 990px) {
    margin: 20px 10px 0 10px;
  }
`;
